import { OnboardingTooltip, TPlacement } from '@cian/ui-kit';
import * as React from 'react';

import { ChatOnboardingContent } from 'shared/components/ChatOnboardingContent';

import { useChatOnboarding } from './hooks/useChatOnboarding';
import { TChatOnboardingType } from './types';

interface IChatOnboardingContainerProps {
  children: React.ReactElement;
  type: TChatOnboardingType;
  placement?: TPlacement;
  minWidth?: '160px' | 'auto';
  maxWidth?: '115px' | 'auto';
  theme?: 'black' | 'blue';
}

export const ChatOnboardingContainer: React.FC<IChatOnboardingContainerProps> = ({
  children,
  type,
  placement = 'left-start',
  minWidth,
  maxWidth,
  theme = 'black',
}) => {
  const { open, onboardingText, closeHandler, ref } = useChatOnboarding(type);

  return (
    <div style={{ position: 'relative' }}>
      <OnboardingTooltip
        theme={theme}
        content={
          <ChatOnboardingContent minWidth={minWidth} maxWidth={maxWidth}>
            {onboardingText}
          </ChatOnboardingContent>
        }
        placement={placement}
        portal={false}
        open={open}
        onClose={closeHandler}
        flip={false}
      >
        <span ref={ref}>{children}</span>
      </OnboardingTooltip>
    </div>
  );
};
